import React from 'react'
import './Comingsoon.scss'

function Comingsoon() {
    return (
        <>
            <section className="comingsoon">
                <div className="container-fluid">
                    <div className="row text-center">
                        <div className="height300 height150-sm"></div>
                        <div className="col-md-12 bg-frame">
                            <div className="text-cooming">COMING SOON</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Comingsoon
